import React, { useEffect, useState } from 'react'
import { TextField, MenuItem, StandardTextFieldProps } from '@mui/material'
import { useWarehouses } from '../../../hooks'
import { Warehouse } from '../../../interfaces'

interface WarehouseDDLProps extends StandardTextFieldProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  name?: string
  valueKey?: 'id' | 'warehouseName'
  required?: boolean
  withoutThisPositions?: number[]
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
  onlyExternalStorage?: boolean
  allowedIds?: number[]
  error?: boolean
  errorText?: string
}

export const WarehouseDDL: React.FC<WarehouseDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  name = 'warehouseId',
  valueKey = 'id',
  required = false,
  withoutThisPositions = [],
  disabled = false,
  size,
  onlyExternalStorage = false,
  allowedIds,
  error = false,
  errorText = 'Seleccionar Almacén',
  ...otherProps
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value === -1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypePositions =
    warehouses !== undefined
      ? warehouses
          .filter((item) => !withoutThisPositions.includes(item.id)) // excluye los items selecionados del dll
          .filter((item) =>
            onlyExternalStorage ? item.withExternalStorage : true
          )
          .filter((item) => (allowedIds ? allowedIds.includes(item.id) : true))
          .map((option: Warehouse) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option.warehouseName}
            </MenuItem>
          ))
      : []

  const isError = () => {
    return hasError || error
  }

  return (
    <TextField
      variant={type}
      id='warehouseId'
      name={name}
      select
      value={value}
      disabled={disabled}
      onChange={onChange}
      fullWidth={fullWidth}
      size={size}
      error={isError()} // Aplicar el estado de error al TextField
      helperText={isError() ? errorText : undefined}
      {...otherProps}
    >
      <MenuItem key={-1} value={-1}>
        {'Seleccionar Almacén...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
